import React from "react";
import { Grid, Col, Row } from '@vds/grids';
import { Body, Title } from '@vds3/typography';
import { Line } from '@vds/lines';
import { RadioButtonGroup } from '@vds3/radio-buttons';
import { useSelector, useDispatch} from "react-redux";
import { TextLink, Button } from "@vds3/buttons";
import { REDIRECT_4G_URL } from "../../../containers/constants";
import { Modal,ModalBody,ModalTitle} from '@vds3/modals'
import { triggerFTRMatrix } from "../../CustomizeOrder/ContractAgreement/containers/action";

let ftrId;
const Qualification = (props) => {
    const [qualifyService, setQualifyService] = React.useState("4G")
    const [showFTRModal,setShowFTRModal] = React.useState(false)
    const { selectedStreetAddress, redirectURL, addressQualificationDetails, cmpCodeQueryParamWirelesss} = useSelector((state) => state.AddressValidationPage)
    const dispatch = useDispatch();
    let serviceOptionsHeader = (props.t && typeof props.t == 'function') ? props.t("fios.serviceOptionsHeader",{ns:"fios"}) : "";
    let lteTitle = (props.t && typeof props.t == 'function') ? props.t("fios.lteTitle",{ns:"fios"}) : "";
    let lteText = (props.t && typeof props.t == 'function') ? props.t("fios.lteText",{ns:"fios"}) : "";
    let otherTitle = (props.t && typeof props.t == 'function') ? props.t("fios.otherTitle",{ns:"fios"}) : "";
    let otherText = (props.t && typeof props.t == 'function') ? props.t("fios.otherText",{ns:"fios"}) : "";
    // let vzNotification = (props.t && typeof props.t == 'function') ? props.t("fios.vzNotification",{ns:"fios"}) : "";
    let routeMsgHeader = (props.t && typeof props.t == 'function') ? props.t("fios.routeMsgHeader",{ns:"fios"}) : "";
    let routeMsgRedirection = (props.t && typeof props.t == 'function') ? props.t("fios.routeMsgRedirection",{ns:"fios"}) : "";
    let routeMsgPolicy = (props.t && typeof props.t == 'function') ? props.t("fios.routeMsgPolicy",{ns:"fios"}) : "";
    
    const serviceQualifyHandler = (service) => {
        if (service === "4G") {
            let cmpCodeForWireless = cmpCodeQueryParamWirelesss ? cmpCodeQueryParamWirelesss : "";
            if (addressQualificationDetails?.GUIEncryptSessionId) {
                if(addressQualificationDetails?.LTERedirectUrl) window.location.href = addressQualificationDetails?.LTERedirectUrl + `?redirectedFrom=GBCOM&lqsessionId=${addressQualificationDetails?.GUIEncryptSessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
                else window.location.href = REDIRECT_4G_URL + `?redirectedFrom=GBCOM&lqsessionId=${addressQualificationDetails?.GUIEncryptSessionId}${cmpCodeForWireless ? `&cmp=${cmpCodeForWireless}` : ""}`
              } else {
                if(addressQualificationDetails?.LTERedirectUrl) window.location.href = addressQualificationDetails?.LTERedirectUrl + `?redirectedFrom=GBCOM`
                else window.location.href = REDIRECT_4G_URL + `?redirectedFrom=GBCOM`
              }
        } else if (service === "FTR") {
            dispatch(triggerFTRMatrix({"LqSessionId":addressQualificationDetails?.GUIEncryptSessionId,"FtrQualified":"Y","RedirectPageShown":"Y","LteRedirected":"N","FtrRedirectd":"Y"}))
            setShowFTRModal(true)
        }
    }
    const handleFtrModalContinue = () => {
        let url = addressQualificationDetails?.ftrQualification?.FtrRedirectUrl;
        window.location.href = url
    }
    React.useEffect(() => {
        if(showFTRModal && qualifyService === "FTR"){
            ftrId= setTimeout(()=>{
                let url = addressQualificationDetails?.ftrQualification?.FtrRedirectUrl;
                window.location.href = url},5000)
        }else{
            clearTimeout(ftrId)
        }
    },[showFTRModal])

    React.useEffect(() => {
        window.scrollTo(0, 0);
    },[])
    return (
        <>
            {qualifyService === "FTR" && showFTRModal === true && <FTRModal openModal={showFTRModal} onOpenChange={(val)=>{setShowFTRModal(val);clearTimeout(ftrId)}} handleFtrModalContinue={()=>handleFtrModalContinue()} routeMsgHeader={routeMsgHeader} routeMsgRedirection={routeMsgRedirection} routeMsgPolicy={routeMsgPolicy}/>}
        <Grid colSizes={{ "mobile": 12, "tablet": 12, "desktop": 12 }} colGutter={true}>
            <Row>
                <Col colSizes={{ "mobile": 12, "tablet": 12, "desktop": 12 }}>
                    <div style={{ marginBottom: "3rem" }}>
                        <Title size="medium" color="#000000" bold>Explore your options</Title>
                    </div>
                </Col>
                <Col colSizes={{ "mobile": 6, "tablet": 6, "desktop": 6 }}>
                    <div style={{ marginBottom: "1.5rem" }}>
                    <Body size="large">{selectedStreetAddress?.disprawstr || ""}</Body>
                    </div>
                </Col>
                <Col colSizes={{ "mobile": 6, "tablet": 6, "desktop": 6 }}><TextLink onClick={() => props.history.push('/')}>Change</TextLink></Col>
                <Col colSizes={{ "mobile": 7, "tablet": 7, "desktop": 7 }}>
                    <Line type="xLight" />
                </Col>
                {serviceOptionsHeader?<Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}>
                    <div style={{marginTop: "2.5rem" }}>
                        <Body size="large">
                            {serviceOptionsHeader}
                        </Body>  
                    </div>
                </Col>:<></>}
                <Col colSizes={{ "mobile": 4, "tablet": 12, "desktop": 12 }}>
                    <div style={{ marginTop: "2.5rem", marginBottom: "2.5rem" }}>
                        <RadioButtonGroup
                            defaultValue={qualifyService ? qualifyService : "businessAddr"}
                            error={false}
                            onChange={(e) => {
                                setQualifyService(e.target.value)
                                // if(e.target.value==="FTR"){
                                //     setShowFTRModal(true)
                                // }else{
                                //     setShowFTRModal(false)
                                // }
                            }}
                            data={[
                                {
                                    name: 'qulifyService',
                                    label: `${lteTitle}`,
                                    children: <Body size="medium">{lteText}</Body>,
                                    value: '4G',
                                    selected: qualifyService === "4G" ? true : false
                                },
                                {
                                    name: 'qulifyService',
                                    label: `${otherTitle}`,
                                    children:  <Body size="medium">{otherText}</Body>,
                                    value: 'FTR',
                                    selected: qualifyService === 'FTR' ? true : false

                                }
                            ]}
                        />
                    </div>
                </Col>
                <Col colSizes={{ "mobile": 6, "tablet": 6, "desktop": 6 }}>
                    <div style={{ display: "flex", gap: "1.3rem" }}>
                        <Button
                            surface="light"
                            disabled={false}
                            use="primary"
                            onClick={() => serviceQualifyHandler(qualifyService)}
                        >
                            Continue
                        </Button>
                        <Button
                            surface="light"
                            disabled={false}
                            use="secondary"
                            onClick={() => props.history.push('/')}
                        >
                            Cancel
                        </Button>
                    </div>
                </Col>
            </Row>

        </Grid>
        </>
    )
}

const FTRModal = ({openModal=false,onOpenChange,handleFtrModalContinue,routeMsgPolicy,routeMsgRedirection,routeMsgHeader}) => {
    return (
        <Modal disableOutsideClick={true} disableFocusLock= {true} opened={openModal} onOpenedChange={(val)=>onOpenChange(val)}>
            <ModalBody>
                <Body size="large" bold>{routeMsgHeader}</Body>
                <Body size="large">
                    <div dangerouslySetInnerHTML={{__html:(routeMsgRedirection ?? "")}}></div>
                </Body>
                <Body size="large">
                    {routeMsgPolicy}
                </Body>
                <div style={{display:"flex",gap:"1.3rem",marginTop:"1.7rem"}}>
                        <Button
                            surface="light"
                            disabled={false}
                            use="primary"
                            onClick={() => handleFtrModalContinue()}
                        >
                            Continue
                        </Button>
                        <Button
                            surface="light"
                            disabled={false}
                            use="secondary"
                            onClick={() => {onOpenChange(false);clearTimeout(ftrId)}}
                        >
                            Cancel
                        </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default Qualification;
